import React, { useState, useRef, useEffect } from 'react';

function CustomDropdown({ label, options, multiple = true, selectedOptions = [], onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleChange = (option) => {
    if (!multiple) {
      // If single selection was needed:
      // onSelect(option);
      // setIsOpen(false);
    } else {
      // multiple selection logic
      let newSelections = [...selectedOptions];
      if (newSelections.includes(option)) {
        newSelections = newSelections.filter(o => o !== option);
      } else {
        newSelections.push(option);
      }
      onSelect(newSelections);
    }
  };

  // Close dropdown if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Display text in the header
  const displayText = selectedOptions.length > 0
    ? selectedOptions.join(', ')
    : label;

  return (
    <div ref={dropdownRef} style={{ position: 'relative', width: '850px', margin: '20px 20px -10px 20px' }}>
      <div
        onClick={handleToggle}
        style={{
          border: '2px solid #80ADF4',
          borderRadius: '8px',
          padding: '10px',
          fontSize: '16px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#fff'
        }}
      >
        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {displayText}
        </span>
        <svg
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
          width="24"
          height="24"
          fill="gray"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </div>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 5px)',
            left: 0,
            width: '100%',
            border: '1px solid #8A8A8A',
            borderRadius: '5px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
            zIndex: 999,
            maxHeight: '200px',
            overflowY: 'auto'
          }}
        >
          {options.map((option, idx) => (
            <label
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '10px',
                borderBottom: idx !== options.length - 1 ? '1px solid #eee' : 'none',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f6f6f6')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
            >
              <input
                type="checkbox"
                checked={selectedOptions.includes(option)}
                onChange={() => handleChange(option)}
                style={{ marginRight: '8px' }}
              />
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {option}
              </span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;
